// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail {
    margin-top: 32px;
}

.restaurant-picture {
    width: 100%;
    height: 400px;
    background-size: cover;
    object-fit: cover;
    object-position: center;
}

.detailRestaurant {
    display: grid;
    text-align: left;
}

.detailRestaurant h2 {
    font-size: 2em;
}

.detailRestaurant p {
    font-size: 1.5em;
}

.detailRestaurant i {
    color: #F7E987;
}

.detailRestaurant-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
}

.detailRestaurant-info p {
    margin: 10px;
}

.detailRestaurant-name {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.detailRestaurant-address {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.detailRestaurant-rate {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.restaurant-description-title {
    text-align: center;
    margin-bottom: 8px;
    color: #F7E987;
}

.restaurant-description {
    text-align: justify;
}

.restaurant-category {
    text-align: left;
}

.restaurant-category-title {
    margin: 10px;
    border-radius: 12px;
    border: 2px solid #F7E987;
    color: #F7E987;
    display: inline-block;
    padding: 15px;
    font-size: 1em;
}

.detailRestaurant-menu h2 {
    font-size: 2.5em;
    color: #F7E987;
}

.restaurant-menu h3 {
    text-align: center;
    font-size: 2em;
    text-decoration: underline;
}

.restaurant-menu p {
    font-size: 1.5em;
    margin: 5px;
}

.restaurant-menu ul {
    margin: 0 auto;
}

.restaurant-menu li {
    list-style-type: none;
    text-align: left;
}

.restaurant-menu i {
    color: #F7E987;
}

.restaurant-review-title {
    text-align: center;
    font-size: 2em;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #F7E987;
}

.review-title {
    font-size: 1.2em;
}

.restaurant-review {
    margin-bottom: 20px;
    margin-top: 10px;
}

.restaurant-review i {
    color: #F7E987;
}

.restaurant-review:hover {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    transition: transform 0.5s ease;
}

.review-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #F7E987;
    padding-bottom: 10px;
    font-size: 1.2em;
}

.review-name {
    font-weight: bold;
    font-size: 1.2rem;
    text-align: left;
}

.review-date {
    font-size: 1rem;
}

.review-comment {
    text-align: left;
    padding-top: 10px;
    font-size: 1.5em;
}

.form-review {
    padding: 10px 20px;
    border: 1px solid;
    border-radius: 5px;
}

.form-review h2 {
    font-size: 2em;
    padding-bottom: 10px;
    color: #F7E987;
}

.form-group {
    flex-direction: row;
    text-align: left;
    margin-top: 10px;
}

.form-group label {
    font-size: 1.8em;
}


.form-control {
    width: 80%;
    padding: 5px;
    margin: 5px;
    font-size: 1rem;
    min-height: 44px;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 2px solid #fff;
    background-color: transparent;
    outline: none;
    color: #fff;
}

.form-control::placeholder {
    color: #F7E987;
    opacity: 70%;
}

.submitReview {
    font-family: 'Plus Jakarta Sans', sans-serif;
    color: #eaeaea;
    font-size: 1rem;
    font-weight: bold;
    margin-top: 10px;
    padding: 20px 10px;
    border-radius: 15px;
    border: 2px solid #F7E987;
    background-color: #252B48;
    cursor: pointer;
    margin: auto;
}

.submitReview:hover {
    background-color: #F7E987;
    color: #252B48;
    transition: transform 0.5s ease;
}

.like {
    font-size: 20px;
    position: fixed;
    bottom: 16px;
    right: 16px;
    background-color: #F7E987;
    color: #252B48;
    border: 1px solid #252B48;
    border-radius: 50%;
    width: 55px;
    height: 55px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .like:hover {
    background-color: #252B48;
    color: #F7E987;
    transition: transform 0.5s ease;
  }

`, "",{"version":3,"sources":["webpack://./src/styles/detail.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,6BAA6B;IAC7B,aAAa;IACb,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,4CAA4C;IAC5C,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,+BAA+B;EACjC","sourcesContent":[".detail {\n    margin-top: 32px;\n}\n\n.restaurant-picture {\n    width: 100%;\n    height: 400px;\n    background-size: cover;\n    object-fit: cover;\n    object-position: center;\n}\n\n.detailRestaurant {\n    display: grid;\n    text-align: left;\n}\n\n.detailRestaurant h2 {\n    font-size: 2em;\n}\n\n.detailRestaurant p {\n    font-size: 1.5em;\n}\n\n.detailRestaurant i {\n    color: #F7E987;\n}\n\n.detailRestaurant-info {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 10px;\n}\n\n.detailRestaurant-info p {\n    margin: 10px;\n}\n\n.detailRestaurant-name {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.detailRestaurant-address {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.detailRestaurant-rate {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.restaurant-description-title {\n    text-align: center;\n    margin-bottom: 8px;\n    color: #F7E987;\n}\n\n.restaurant-description {\n    text-align: justify;\n}\n\n.restaurant-category {\n    text-align: left;\n}\n\n.restaurant-category-title {\n    margin: 10px;\n    border-radius: 12px;\n    border: 2px solid #F7E987;\n    color: #F7E987;\n    display: inline-block;\n    padding: 15px;\n    font-size: 1em;\n}\n\n.detailRestaurant-menu h2 {\n    font-size: 2.5em;\n    color: #F7E987;\n}\n\n.restaurant-menu h3 {\n    text-align: center;\n    font-size: 2em;\n    text-decoration: underline;\n}\n\n.restaurant-menu p {\n    font-size: 1.5em;\n    margin: 5px;\n}\n\n.restaurant-menu ul {\n    margin: 0 auto;\n}\n\n.restaurant-menu li {\n    list-style-type: none;\n    text-align: left;\n}\n\n.restaurant-menu i {\n    color: #F7E987;\n}\n\n.restaurant-review-title {\n    text-align: center;\n    font-size: 2em;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    color: #F7E987;\n}\n\n.review-title {\n    font-size: 1.2em;\n}\n\n.restaurant-review {\n    margin-bottom: 20px;\n    margin-top: 10px;\n}\n\n.restaurant-review i {\n    color: #F7E987;\n}\n\n.restaurant-review:hover {\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n    transition: transform 0.5s ease;\n}\n\n.review-header {\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 1px solid #F7E987;\n    padding-bottom: 10px;\n    font-size: 1.2em;\n}\n\n.review-name {\n    font-weight: bold;\n    font-size: 1.2rem;\n    text-align: left;\n}\n\n.review-date {\n    font-size: 1rem;\n}\n\n.review-comment {\n    text-align: left;\n    padding-top: 10px;\n    font-size: 1.5em;\n}\n\n.form-review {\n    padding: 10px 20px;\n    border: 1px solid;\n    border-radius: 5px;\n}\n\n.form-review h2 {\n    font-size: 2em;\n    padding-bottom: 10px;\n    color: #F7E987;\n}\n\n.form-group {\n    flex-direction: row;\n    text-align: left;\n    margin-top: 10px;\n}\n\n.form-group label {\n    font-size: 1.8em;\n}\n\n\n.form-control {\n    width: 80%;\n    padding: 5px;\n    margin: 5px;\n    font-size: 1rem;\n    min-height: 44px;\n    border-top: 0;\n    border-left: 0;\n    border-right: 0;\n    border-bottom: 2px solid #fff;\n    background-color: transparent;\n    outline: none;\n    color: #fff;\n}\n\n.form-control::placeholder {\n    color: #F7E987;\n    opacity: 70%;\n}\n\n.submitReview {\n    font-family: 'Plus Jakarta Sans', sans-serif;\n    color: #eaeaea;\n    font-size: 1rem;\n    font-weight: bold;\n    margin-top: 10px;\n    padding: 20px 10px;\n    border-radius: 15px;\n    border: 2px solid #F7E987;\n    background-color: #252B48;\n    cursor: pointer;\n    margin: auto;\n}\n\n.submitReview:hover {\n    background-color: #F7E987;\n    color: #252B48;\n    transition: transform 0.5s ease;\n}\n\n.like {\n    font-size: 20px;\n    position: fixed;\n    bottom: 16px;\n    right: 16px;\n    background-color: #F7E987;\n    color: #252B48;\n    border: 1px solid #252B48;\n    border-radius: 50%;\n    width: 55px;\n    height: 55px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .like:hover {\n    background-color: #252B48;\n    color: #F7E987;\n    transition: transform 0.5s ease;\n  }\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
